import React, { useState, useEffect } from "react";
import "../styles/AddImovel.css";
import { useNavigate, useParams } from "react-router-dom";
import { storage, db } from "../../firebaseConfig";
import {
  ref as storageRef,
  uploadBytesResumable,
  getDownloadURL,
  deleteObject
} from "firebase/storage";
import { onValue, ref as databaseRef, update, get, set } from "firebase/database";

import { Alert, Snackbar } from "@mui/material";

import imageCompression from "browser-image-compression";

import { buildPublicImovel } from "../../utils/buildPublicImovel";

const EditImovel = () => {

  const { id } = useParams();

  const [cidades, setCidades] = useState([]);
  const [cidadeSelecionada, setCidadeSelecionada] = useState("");
  const [bairros, setBairros] = useState([]);
  const [draggedId, setDraggedId] = useState(null);

  const [atributosFirebase, setAtributosFirebase] = useState([]);

  const navigate = useNavigate();

  const [corretores, setCorretores] = useState([]);

  const [imovelInfo, setImovelInfo] = useState({
    corretor: "",
    codigo: "",
    construtora: "",
    titulo: "",
    modalidade: "",
    cidade: "",
    bairro: "",
    endereco: "",
    complemento: "",
    referencia: "",
    cep: "",
    tipo: "",
    descricao: "",
    descricaoInterna: "",
  });

  const [ownerInfo, setOwnerInfo] = useState({
    nome: "",
    sobrenome: "",
    cpf: "",
    telefone: "",
    telefone2: "",
    birth: "",
    email: "",
    conjuge: "",
  });

  const [caracteristicas, setCaracteristicas] = useState({
    areaTerreno: "",
    areaConstruida: "",
    areaTerrenoH: "",
    banheiros: "",
    lavabos: "",
    suites: "",
    quartos: "",
    vagas: "",
    areaGourmet: "",
    posicao: "",
    sacadas: "",
    salas: "",
    varanda: "",
    pavimentos: "",
    cozinha: "",
    comodos: "",
    areasServico: "",
    copas: "",
    areaPrivativa: "",
    frente: "",
    lateralDireita: "",
    lateralEsquerda: "",
    fundos: "",
  });

  const [informacoesComerciais, setInformacoesComerciais] = useState({
    tipoVenda: "",
    valor: "",
    comissaoPercentual: "",
    comissaoValor: "",
    iptu: "",
    condominio: "",
  });

  const [informacoesAdicionais, setInformacoesAdicionais] = useState({
    chaveImobiliaria: "",
    placa: "",
    exclusivo: "",
    parceria: "",
    nomeParceria: "",
    numeroIptu: "",
    numeroMatricula: "",
    codigoDamae: "",
    numeroEnergiaEletrica: "",
    numeroInstalacaoEletrica: "",
    linkLocalizacao: "",
  });

  const [selectedItems, setSelectedItems] = useState([]);

  const [bookTecnicoFile, setBookTecnicoFile] = useState(null);
  const [bookTecnicoURL, setBookTecnicoURL] = useState("");
  const [bookTecnicoChanged, setBookTecnicoChanged] = useState(false);

  const mergeWithDefaults = (defaults, data) => ({
    ...defaults,
    ...(data || {}),
  });

  const convertToWebP = async (file) => {
    try {
      const options = {
        fileType: "image/webp",
        initialQuality: 0.8, // 80% de qualidade
        maxWidthOrHeight: 1920, // opcional: redimensionar se quiser limitar tamanho
      };
      const compressedFile = await imageCompression(file, options);
      return compressedFile;
    } catch (error) {
      console.error("Erro ao converter imagem para WEBP:", error);
      return file; // fallback
    }
  };


  const formatCEP = (cep) => {
    let cleanCep = cep.replace(/\D/g, "");
    if (cleanCep.length > 8) {
      cleanCep = cleanCep.slice(0, 8);
    }
    return cleanCep.replace(/^(\d{2})(\d{3})(\d{3})$/, "$1.$2-$3");
  };

  const formatBRL = (valor) => {
    let cleanValue = valor.replace(/\D/g, "");
    if (cleanValue === "") return "";
    let formattedValue = (parseFloat(cleanValue) / 100).toLocaleString(
      "pt-BR",
      {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      }
    );
    return formattedValue;
  };

  const formatPercentage = (valor) => {
    let cleanValue = valor.replace(/\D/g, "");
    let numericValue = Math.min(parseInt(cleanValue, 10) || 0, 100);
    return `${numericValue}%`;
  };

  function formatCPF(value) {
    value = value.replace(/\D/g, "");
    value = value.slice(0, 11);
    return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{0,2})$/, "$1.$2.$3-$4");
  }

  function formatNumber(value) {
    value = value.replace(/\D/g, "");
    value = value.slice(0, 11);
    return value
      .replace(/^(\d{2})(\d{5})(\d{0,4})$/, "($1) $2-$3")
      .replace(/^(\d{2})(\d{4})(\d{0,4})$/, "($1) $2-$3");
  }

  function formatDate(value) {
    value = value.replace(/\D/g, "");
    value = value.slice(0, 8);
    return value.replace(/^(\d{2})(\d{2})(\d{0,4})$/, "$1/$2/$3");
  }

  const calcularComissao = (valor, percentual) => {
    let valorNumerico = parseFloat(valor.replace(/\D/g, "")) / 100 || 0;
    let percentualNumerico =
      parseFloat(percentual.replace(/\D/g, "")) / 100 || 0;
    let comissao = valorNumerico * percentualNumerico;
    return formatBRL(comissao.toFixed(2));
  };

  const handleChange = (e, section, setSectionState) => {
    const { name, value } = e.target;

    let realValue = value;

    if (name === "cep") {
      realValue = formatCEP(realValue);
    } else if (
      ["valor", "comissaoValor", "iptu", "condominio"].includes(name)
    ) {
      realValue = formatBRL(realValue);
    } else if (name === "comissaoPercentual") {
      realValue = formatPercentage(realValue);
    } else if (name === "construtora" && value === "false") {
      setSectionState((prevState) => ({
        ...prevState,
        titulo: "",
      }));
    } else if (name === "cpf") {
      realValue = formatCPF(realValue);
    } else if (name === "telefone" || name === "telefone2") {
      realValue = formatNumber(realValue);
    } else if (name === "birth") {
      realValue = formatDate(realValue);
    }

    const camposDecimais = [
      "frente",
      "fundos",
      "lateralDireita",
      "lateralEsquerda",
      "areaTerrenoH",
      "areaConstruida",
      "areaTerreno",
    ];

    if (
      setSectionState === setCaracteristicas &&
      camposDecimais.includes(name)
    ) {
      realValue = realValue.replace(/[^0-9.,]/g, "");
    }

    // Atualiza informacoesComerciais apenas quando estiver lidando com ela
    if (setSectionState === setInformacoesComerciais) {
      setInformacoesComerciais((prevState) => {
        const updatedState = { ...prevState, [name]: realValue };

        if (updatedState.valor && updatedState.comissaoPercentual) {
          updatedState.comissaoValor = calcularComissao(
            updatedState.valor,
            updatedState.comissaoPercentual
          );
        }

        return updatedState;
      });
    } else {
      setSectionState((prevState) => ({
        ...prevState,
        [name]: realValue,
      }));
    }
  };

  useEffect(() => {
    const atributosRef = databaseRef(db, "atributos");
    onValue(atributosRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const listaAtributos = Object.values(data).sort((a, b) =>
          a.localeCompare(b)
        );
        setAtributosFirebase(listaAtributos);
      } else {
        setAtributosFirebase([]);
      }
    });
  }, []);

  useEffect(() => {
    const corretorRef = databaseRef(db, "corretores/");
    onValue(corretorRef, (snapshot) => {
      const data = snapshot.val();

      if (data) {
        const allCorretores = Object.values(data).reverse();

        setCorretores(allCorretores);
      } else {
        setCorretores([]);
      }
    });
  }, [id]);

  useEffect(() => {
    const getImovelRef = databaseRef(db, `imoveis/${id}`);

    get(getImovelRef)
      .then((snapshot) => {
        const data = snapshot.val();

        if (data) {
          setImovelInfo((prev) => mergeWithDefaults(prev, data.imovelInfo));
          setOwnerInfo((prev) => mergeWithDefaults(prev, data.ownerInfo));
          setCaracteristicas((prev) => mergeWithDefaults(prev, data.caracteristicas));
          setInformacoesComerciais((prev) =>
            mergeWithDefaults(prev, data.informacoesComerciais)
          );
          setInformacoesAdicionais((prev) =>
            mergeWithDefaults(prev, data.informacoesAdicionais)
          );
          setSelectedItems(data.selectedItems || []);

          if (data.bookTecnicoURL) {
            setBookTecnicoURL(data.bookTecnicoURL);
          } else {
            setBookTecnicoURL("");
          }

          if (data.imovelInfo && data.imovelInfo.cidade) {
            setCidadeSelecionada(data.imovelInfo.cidade);
          }

          if (data.selectedItems && Array.isArray(data.selectedItems)) {
            setSelectedItems(data.selectedItems);
          } else {
            setSelectedItems([]);
          }

          if (data.imagesLinks) {
            const sortedImages = Object.entries(data.imagesLinks)
              .sort((a, b) => parseInt(a[0]) - parseInt(b[0]))
              .map(([key, url]) => ({
                id: `old-${key}`,   // id estável pro front
                url,                // ✅ só URL
                isNew: false,
                file: null,
                toRemove: false,
              }));

            setSelectedImages(sortedImages);
          } else {
            setSelectedImages([]);
          }

        } else {
          navigate("/panel/lista-imoveis");
        }
      })
      .catch((error) => {
        console.error("Erro ao buscar o imóvel:", error);
        setAlertMessage("Erro ao carregar os dados do imóvel.");
        setAlertType("error");
        setOpenAlert(true);
      });
  }, [id, navigate]);

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    setSelectedItems((prevSelected) =>
      checked
        ? [...prevSelected, value]
        : prevSelected.filter((item) => item !== value)
    );
  };

  useEffect(() => {
    const fetchCidades = async () => {
      try {
        const locRef = databaseRef(db, "loc/cidades/");
        const snapshot = await get(locRef);
        if (snapshot.exists()) {
          const data = snapshot.val();
          const cidadeArray = Object.keys(data)
            .map((key) => ({
              id: key,
              nome: data[key].nome,
              bairros: data[key].bairros
                ? Object.values(data[key].bairros)
                : [],
            }))
            .sort((a, b) => a.nome.localeCompare(b.nome));

          setCidades(cidadeArray);

          // Se já temos um imóvel carregado, definir a cidade e os bairros corretamente
          if (imovelInfo.cidade) {
            const cidadeSalva = cidadeArray.find(
              (c) => c.nome === imovelInfo.cidade
            );
            if (cidadeSalva) {
              setCidadeSelecionada(cidadeSalva.id);
              setBairros(cidadeSalva.bairros);
            }
          }
        }
      } catch (error) {
        console.error("Erro ao buscar cidades:", error);
      }
    };

    fetchCidades();
  }, [imovelInfo.cidade]); // Certifique-se de rodar o efeito quando o imóvel for carregado

  // Função para mudar a cidade ao editar o imóvel
  const handleCidadeChange = (e) => {
    const cidadeId = e.target.value;
    setCidadeSelecionada(cidadeId);

    const cidadeSelecionada = cidades.find((c) => c.id === cidadeId);
    setBairros(cidadeSelecionada ? cidadeSelecionada.bairros : []);

    setImovelInfo((prevState) => ({
      ...prevState,
      cidade: cidadeSelecionada ? cidadeSelecionada.nome : "",
      bairro: "", // Reset do bairro ao trocar de cidade
    }));
  };

  // Função para mudar o bairro ao editar o imóvel
  const handleBairroChange = (e) => {
    setImovelInfo((prevState) => ({
      ...prevState,
      bairro: e.target.value,
    }));
  };

  const [selectedImages, setSelectedImages] = useState([]);

  const MAX_IMAGES = 100;

  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [openAlert, setOpenAlert] = useState(false);

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    if (selectedImages.length + files.length > MAX_IMAGES) {
      alert(`Você pode adicionar no máximo ${MAX_IMAGES} imagens.`);
      return;
    }

    const stamped = Date.now();
    const newFiles = files.map((file, idx) => ({
      id: `new-${stamped}-${idx}`,
      file,
      url: URL.createObjectURL(file),
      isNew: true,
      toRemove: false,
    }));

    setSelectedImages((prev) => [...prev, ...newFiles]);
  };

  const handleRemoveImage = (imageId) => {
    setSelectedImages((prev) =>
      prev.map((img) =>
        img.id === imageId ? { ...img, toRemove: true } : img
      )
    );
  };

  const handleBookTecnicoChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type === "application/pdf") {
      setBookTecnicoFile(file);
      setBookTecnicoChanged(true);
    } else {
      setAlertMessage("Selecione um arquivo PDF válido.");
      setAlertType("error");
      setOpenAlert(true);
    }
  };

  const handleRemoveBookTecnico = async () => {
    if (bookTecnicoURL) {
      try {
        // Apaga do Storage
        const pdfRef = storageRef(storage, `imoveis/${id}/bookTecnico.pdf`);
        await deleteObject(pdfRef);
        console.log("Book Técnico removido do storage.");
      } catch (err) {
        console.warn("Book Técnico não encontrado no storage:", err);
      }
    }
    setBookTecnicoFile(null);
    setBookTecnicoURL("");
    setBookTecnicoChanged(true); // indica que precisa atualizar no DB
  };

  const sanitizeKey = (key) => key.replace(/[.#$/\[\]]/g, "_");

  const sanitizeObjectKeys = (obj) => {
    const result = {};
    Object.entries(obj || {}).forEach(([key, value]) => {
      result[sanitizeKey(key)] = value;
    });
    return result;
  };

  const deepDiff = (before, after, path = "") => {
    let changes = {};

    const isObject = (v) =>
      v && typeof v === "object" && !Array.isArray(v);

    const keys = new Set([
      ...Object.keys(before || {}),
      ...Object.keys(after || {}),
    ]);

    keys.forEach((key) => {
      const newPath = path ? `${path}.${key}` : key;

      const b = before?.[key];
      const a = after?.[key];

      // Array
      if (Array.isArray(b) || Array.isArray(a)) {
        if (JSON.stringify(b) !== JSON.stringify(a)) {
          changes[newPath] = { before: b ?? null, after: a ?? null };
        }
        return;
      }

      // Object
      if (isObject(b) && isObject(a)) {
        Object.assign(changes, deepDiff(b, a, newPath));
        return;
      }

      // Primitive
      if (b !== a) {
        changes[newPath] = { before: b ?? null, after: a ?? null };
      }
    });

    return changes;
  };

  const deepClean = (obj) => {
    Object.keys(obj).forEach((k) => {
      if (obj[k] === undefined) {
        delete obj[k];
      } else if (obj[k] && typeof obj[k] === "object" && !Array.isArray(obj[k])) {
        deepClean(obj[k]);
      }
    });
  };

  const deleteByDownloadUrl = async (downloadUrl) => {
    try {
      if (!downloadUrl) return;

      const encodedPath = downloadUrl.split("/o/")[1]?.split("?")[0];
      if (!encodedPath) return;

      const fullPath = decodeURIComponent(encodedPath); // ex: imoveis/ID/arquivo.webp
      const fileRef = storageRef(storage, fullPath);
      await deleteObject(fileRef);
    } catch (err) {
      console.warn("Falha ao deletar imagem (ignorando):", err);
    }
  };

  const handleSave = async () => {
    // ===============================
    // 1) VALIDAÇÃO (IGUAL AO AddImovel)
    // ===============================

    const camposObrigatorios = {
      imovelInfo: [
        "corretor",
        "construtora",
        "titulo",
        "modalidade",
        "cidade",
        "bairro",
        "endereco",
        "tipo",
        "descricao",
      ],
      ownerInfo: [
        "nome",
        "sobrenome",
        "cpf",
        "telefone",
      ],
      informacoesComerciais: [
        "tipoVenda",
        "valor",
        "comissaoPercentual",
        "comissaoValor",
      ],
      informacoesAdicionais: [
        "chaveImobiliaria",
        "placa",
        "exclusivo",
        "parceria",
        "linkLocalizacao",
      ],
    };

    const camposVazios = [];

    Object.entries(camposObrigatorios).forEach(([section, fields]) => {
      const sectionData =
        section === "imovelInfo"
          ? imovelInfo
          : section === "ownerInfo"
            ? ownerInfo
            : section === "informacoesComerciais"
              ? informacoesComerciais
              : informacoesAdicionais;

      fields.forEach((campo) => {
        if (!String(sectionData?.[campo] ?? "").trim()) {
          camposVazios.push(`${section}.${campo}`);
        }
      });
    });

    if (camposVazios.length > 0) {
      setAlertMessage(
        `Preencha os campos obrigatórios: ${camposVazios.join(", ")}`
      );
      setAlertType("error");
      setOpenAlert(true);
      return;
    }

    // ===============================
    // 2) VALIDAÇÃO DE IMAGENS
    // ===============================

    const imagensVisiveis = selectedImages.filter(img => !img.toRemove);

    if (imagensVisiveis.length < 3) {
      setAlertMessage("O imóvel deve possuir no mínimo 3 imagens.");
      setAlertType("error");
      setOpenAlert(true);
      return;
    }

    try {
      // ===============================
      // 3) BUSCA IMÓVEL ATUAL
      // ===============================

      const imovelRef = databaseRef(db, `imoveis/${id}`);
      const snap = await get(imovelRef);
      const currentData = snap.val();

      if (!currentData) {
        setAlertMessage("Imóvel não encontrado.");
        setAlertType("error");
        setOpenAlert(true);
        return;
      }

      // ===============================
      // 4) HELPERS
      // ===============================

      const uploadViaResumable = (fileRef, file) =>
        new Promise((resolve, reject) => {
          const task = uploadBytesResumable(fileRef, file);
          task.on(
            "state_changed",
            null,
            (err) => reject(err),
            async () => {
              try {
                const url = await getDownloadURL(task.snapshot.ref);
                resolve(url);
              } catch (e) {
                reject(e);
              }
            }
          );
        });

      // ===============================
      // 5) REMOVE IMAGENS MARCADAS
      // ===============================

      const toRemove = selectedImages.filter(img => img.toRemove && !img.isNew);
      for (const img of toRemove) {
        await deleteByDownloadUrl(img.url);
      }

      // ===============================
      // 6) REORGANIZA / ENVIA IMAGENS
      // ===============================

      const finalImagesLinks = {};
      let newIndex = 0;

      for (const img of selectedImages) {
        if (img.toRemove) continue;

        if (img.isNew) {
          const webpFile = await convertToWebP(img.file);

          // ✅ nome único pra não sobrescrever nada
          const fileRef = storageRef(
            storage,
            `imoveis/${id}/${Date.now()}-${newIndex}.webp`
          );

          const url = await uploadViaResumable(fileRef, webpFile);

          // ✅ salva só URL no formato antigo
          finalImagesLinks[newIndex] = url;
        } else {
          // ✅ imagem antiga: reaproveita URL sem mexer
          finalImagesLinks[newIndex] = img.url;
        }

        newIndex++;
      }

      // ===============================
      // 7) BOOK TÉCNICO (PDF)
      // ===============================

      let finalBookURL = bookTecnicoURL;

      if (bookTecnicoFile) {
        const pdfRef = storageRef(storage, `imoveis/${id}/bookTecnico.pdf`);
        const uploadTask = uploadBytesResumable(pdfRef, bookTecnicoFile);

        await new Promise((resolve, reject) => {
          uploadTask.on(
            "state_changed",
            null,
            (error) => reject(error),
            async () => {
              finalBookURL = await getDownloadURL(uploadTask.snapshot.ref);
              resolve();
            }
          );
        });
      } else if (bookTecnicoChanged && !bookTecnicoURL) {
        finalBookURL = "";
      }

      // ===============================
      // 8) SALVA NO FIREBASE
      // ===============================


      const payload = {
        imovelInfo: mergeWithDefaults(currentData.imovelInfo || {}, imovelInfo),
        ownerInfo: mergeWithDefaults(currentData.ownerInfo || {}, ownerInfo),
        caracteristicas: mergeWithDefaults(
          currentData.caracteristicas || {},
          caracteristicas
        ),
        informacoesComerciais: mergeWithDefaults(
          currentData.informacoesComerciais || {},
          informacoesComerciais
        ),
        informacoesAdicionais: mergeWithDefaults(
          currentData.informacoesAdicionais || {},
          informacoesAdicionais
        ),
        selectedItems: Array.isArray(selectedItems) ? selectedItems : [],
        imagesLinks: finalImagesLinks,
        bookTecnicoURL: finalBookURL,
      };

      deepClean(payload);

      // ===============================
      // 8.1) CALCULA DIFF PARA LOG
      // ===============================

      let changes = {};

      try {
        const rawChanges = deepDiff(currentData || {}, {
          ...(currentData || {}),
          ...(payload || {}),
        });

        changes = sanitizeObjectKeys(rawChanges);
      } catch (err) {
        console.warn("Falha ao calcular diff, ignorando log:", err);
        changes = {};
      }

      // ===============================
      // 8.1.1) RECONFERE EXISTÊNCIA (mesma classe de proteção do incidente
      // do imóvel #200)
      // ===============================

      // `currentData` foi lido no início da função, antes do upload de
      // imagens/PDF — que pode levar segundos ou minutos. Se o registro foi
      // apagado nesse meio-tempo (por outro admin, por exemplo), o
      // update() abaixo recriaria um nó parcial (com imovelInfo mas sem
      // control) em vez de simplesmente falhar. Reconferimos bem antes de
      // escrever.
      const preSaveSnap = await get(imovelRef);
      if (!preSaveSnap.exists()) {
        setAlertMessage(
          "Este imóvel foi removido por outra pessoa durante a edição. Nada foi salvo."
        );
        setAlertType("error");
        setOpenAlert(true);
        return;
      }

      // ===============================
      // 8.2) SALVA IMÓVEL (COMO JÁ ERA)
      // ===============================

      await update(imovelRef, payload);

      // ===============================
      // 8.2.1) SINCRONIZA /imoveisPublicos
      // ===============================

      // `payload` nunca inclui `control`, então este update() já não mexe em
      // control/watermarked. Ainda assim relemos o nó (read-after-write) em vez
      // de usar `currentData` (capturado no início do save, antes do upload das
      // imagens) para não publicar um watermarked desatualizado.
      const freshSnap = await get(imovelRef);
      const freshImovel = freshSnap.val() || {};

      const publicData = buildPublicImovel(id, freshImovel);
      await set(databaseRef(db, `imoveisPublicos/${id}`), publicData);

      // ===============================
      // 8.3) SALVA LOG DETALHADO
      // ===============================

      if (Object.keys(changes).length > 0) {
        const now = new Date();
        const dayPath = now.toISOString().slice(0, 10);
        const timestamp = now.getTime();

        const logRef = databaseRef(
          db,
          `logs/${dayPath}/${timestamp}/${imovelInfo.codigo || id}`
        );

        await set(logRef, {
          imovelId: id,
          codigo: imovelInfo.codigo || null,
          timestamp,
          isoDate: now.toISOString(),
          changes,
        });
      }

      // ===============================
      // 9) FINALIZA
      // ===============================

      setAlertMessage("Imóvel atualizado com sucesso!");
      setAlertType("success");
      setOpenAlert(true);

      setBookTecnicoFile(null);
      setBookTecnicoChanged(false);

      setTimeout(() => {
        navigate("/panel/lista-imoveis");
      }, 1500);

    } catch (err) {
      // console.error(err);
      console.error("ERRO REAL:", err);
      setAlertMessage("Erro ao salvar imóvel. Tente novamente.");
      setAlertType("error");
      setOpenAlert(true);
    }
  };



  return (
    <div className="add-page">
      <h1>Editar Imóvel | {imovelInfo.codigo}</h1>
      <div className="containerAddImovel">
        <h3>Informações Básicas</h3>
        <div className="containerOne">
          <div className="input-groupText">
            <label className="labelText">Corretor</label>
            <select
              name="corretor"
              value={imovelInfo.corretor}
              onChange={(e) => handleChange(e, imovelInfo, setImovelInfo)}
              className="selectInputText"
            >
              <option value="" disabled>
                Selecione um corretor
              </option>
              {Object.values(corretores).map((corretor, index) => (
                <option key={index} value={corretor.id}>
                  {corretor.nome}
                </option>
              ))}
            </select>
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Tipo do Imóvel</label>
            <select
              name="tipo"
              value={imovelInfo.tipo}
              onChange={(e) => handleChange(e, imovelInfo, setImovelInfo)}
              className="selectInputText"
              type="text"
            >
              <option value="" disabled>
                Selecione uma opção
              </option>
              <option value="Casa">CASA</option>
              <option value="Apartamento">APARTAMENTO</option>
              <option value="Lote">LOTE</option>
              <option value="Pousada">POUSADA</option>
              <option value="Sitio">SÍTIO</option>
              <option value="Fazenda">FAZENDA</option>
              <option value="Terreno">TERRENO</option>
              <option value="Galpão">GALPÃO</option>
              <option value="Sala Comercial">SALA COMERCIAL</option>
              <option value="Imovel Comercial">IMÓVEL COMERCIAL</option>
              <option value="Imovel na Planta">IMÓVEL NA PLANTA</option>
              <option value="Chale">CHALÉ</option>
              <option value="Kitnet">KITNET</option>
              <option value="Em Construcao">EM CONSTRUÇÃO</option>
            </select>
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Construtora</label>
            <select
              name="construtora"
              value={imovelInfo.construtora}
              onChange={(e) => handleChange(e, imovelInfo, setImovelInfo)}
              className="selectInputText"
              type="text"
            >
              <option value="" disabled>
                Selecione uma opção
              </option>
              <option value="true">SIM</option>
              <option value="false">NÃO</option>
            </select>
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Título Imóvel</label>
            <input
              name="titulo"
              onChange={(e) => handleChange(e, imovelInfo, setImovelInfo)}
              value={imovelInfo.titulo}
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Modalidade</label>
            <select
              name="modalidade"
              value={imovelInfo.modalidade}
              onChange={(e) => handleChange(e, imovelInfo, setImovelInfo)}
              className="selectInputText"
              type="text"
            >
              <option value="" disabled>
                Selecione uma opção
              </option>
              <option value="Venda">VENDA</option>
              <option value="Aluguel">ALUGUEL</option>
              <option value="Temporada">TEMPORADA</option>
            </select>
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Cidade (MG)</label>
            <select
              name="cidade"
              className="selectInputText"
              value={cidadeSelecionada}
              onChange={handleCidadeChange}
            >
              <option value="" disabled>
                Selecione uma cidade
              </option>
              {cidades.map((cidade) => (
                <option key={cidade.id} value={cidade.id}>
                  {cidade.nome}
                </option>
              ))}
            </select>
          </div>

          <div className="input-groupText">
            <label className="labelText">Bairro</label>
            <select
              name="bairro"
              className="selectInputText"
              value={imovelInfo.bairro}
              onChange={handleBairroChange}
            >
              <option value="" disabled>
                Selecione um bairro
              </option>
              {bairros.map((bairro, index) => (
                <option key={index} value={bairro}>
                  {bairro}
                </option>
              ))}
            </select>
          </div>

          <div className="input-groupText">
            <label className="labelText">Endereço do Imóvel</label>
            <input
              name="endereco"
              value={imovelInfo.endereco}
              onChange={(e) => handleChange(e, imovelInfo, setImovelInfo)}
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Complemento</label>
            <input
              name="complemento"
              value={imovelInfo.complemento}
              onChange={(e) => handleChange(e, imovelInfo, setImovelInfo)}
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Referência</label>
            <input
              name="referencia"
              value={imovelInfo.referencia}
              onChange={(e) => handleChange(e, imovelInfo, setImovelInfo)}
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">CEP do Imóvel</label>
            <input
              name="cep"
              value={imovelInfo.cep}
              onChange={(e) => handleChange(e, imovelInfo, setImovelInfo)}
              className="inputText"
              type="text"
            />
            <div></div>
          </div>
        </div>

        <h3>Informações do Proprietário</h3>
        <div className="containerOne">

          <div className="input-groupText">
            <label className="labelText">Nome</label>
            <input
              name="nome"
              value={ownerInfo.nome}
              onChange={(e) => handleChange(e, ownerInfo, setOwnerInfo)}
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Sobrenome</label>
            <input
              name="sobrenome"
              value={ownerInfo.sobrenome}
              onChange={(e) => handleChange(e, ownerInfo, setOwnerInfo)}
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">CPF</label>
            <input
              name="cpf"
              value={ownerInfo.cpf}
              onChange={(e) => handleChange(e, ownerInfo, setOwnerInfo)}
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Data de Nascimento</label>
            <input
              name="birth"
              value={ownerInfo.birth}
              onChange={(e) => handleChange(e, ownerInfo, setOwnerInfo)}
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Telefone</label>
            <input
              name="telefone"
              value={ownerInfo.telefone}
              onChange={(e) => handleChange(e, ownerInfo, setOwnerInfo)}
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Cônjuge</label>
            <input
              name="conjuge"
              value={ownerInfo.conjuge}
              onChange={(e) => handleChange(e, ownerInfo, setOwnerInfo)}
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Telefone Cônjuge</label>
            <input
              name="telefone2"
              value={ownerInfo.telefone2}
              onChange={(e) => handleChange(e, ownerInfo, setOwnerInfo)}
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Email do Proprietário</label>
            <input
              name="email"
              value={ownerInfo.email}
              onChange={(e) => handleChange(e, ownerInfo, setOwnerInfo)}
              className="inputText"
              type="email"
            />
          </div>
        </div>

        <h3>Caracteristicas do Imóvel</h3>
        <div className="containerOne">
          <div className="input-groupText">
            <label className="labelText">Área terreno (m²)</label>
            <input
              name="areaTerreno"
              value={caracteristicas.areaTerreno}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Área construída (m²)</label>
            <input
              name="areaConstruida"
              value={caracteristicas.areaConstruida}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Área Terreno HECTARE (He)</label>
            <input
              name="areaTerrenoH"
              value={caracteristicas.areaTerrenoH}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Banheiros</label>
            <input
              name="banheiros"
              value={caracteristicas.banheiros}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Lavabos</label>
            <input
              name="lavabos"
              value={caracteristicas.lavabos}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Suítes</label>
            <input
              name="suites"
              value={caracteristicas.suites}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Quartos</label>
            <input
              name="quartos"
              value={caracteristicas.quartos}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Vagas</label>
            <input
              name="vagas"
              value={caracteristicas.vagas}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Posição</label>
            <input
              name="posicao"
              value={caracteristicas.posicao}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Área Gourmet</label>
            <select
              name="areaGourmet"
              value={caracteristicas.areaGourmet}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="selectInputText"
              type="text"
            >
              <option value="" disabled>
                Selecione uma opção
              </option>
              <option value="true">SIM</option>
              <option value="false">NÃO</option>
            </select>
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Sacadas</label>
            <input
              name="sacadas"
              value={caracteristicas.sacadas}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Salas</label>
            <input
              name="salas"
              value={caracteristicas.salas}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Varanda</label>
            <input
              name="varanda"
              value={caracteristicas.varanda}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Pavimentos</label>
            <input
              name="pavimentos"
              value={caracteristicas.pavimentos}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Cozinha</label>
            <input
              name="cozinha"
              value={caracteristicas.cozinha}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Áreas de serviço</label>
            <input
              name="areasServico"
              value={caracteristicas.areasServico}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Copas</label>
            <input
              name="copas"
              value={caracteristicas.copas}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Área privativa</label>
            <input
              name="areaPrivativa"
              value={caracteristicas.areaPrivativa}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Lateral Direita</label>
            <input
              name="lateralDireita"
              value={caracteristicas.lateralDireita}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Lateral Esquerda</label>
            <input
              name="lateralEsquerda"
              value={caracteristicas.lateralEsquerda}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Frente</label>
            <input
              name="frente"
              value={caracteristicas.frente}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Fundos</label>
            <input
              name="fundos"
              value={caracteristicas.fundos}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="text"
            />
            <div></div>
          </div>
        </div>

        <h3>Atributos</h3>
        <div className="containerOne">
          <div className="atributosContainer">
            {atributosFirebase.map((item, index) => (
              <div key={index}>
                <input
                  style={{ marginTop: "10px" }}
                  type="checkbox"
                  id={item}
                  value={item}
                  checked={selectedItems.includes(item)}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor={item}>{item}</label>
              </div>
            ))}
          </div>
        </div>

        <h3>Informações Comerciais</h3>
        <div className="containerOne">
          <div className="input-groupText">
            <label className="labelText">Tipo Venda</label>
            <select
              name="tipoVenda"
              value={informacoesComerciais.tipoVenda}
              onChange={(e) =>
                handleChange(e, informacoesComerciais, setInformacoesComerciais)
              }
              className="selectInputText"
              type="text"
            >
              <option value="" disabled>
                Selecione uma opção
              </option>
              <option value="a partir de">A PARTIR DE</option>
              <option value="valor">VALOR</option>
            </select>
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Valor</label>
            <input
              name="valor"
              value={informacoesComerciais.valor}
              onChange={(e) =>
                handleChange(e, informacoesComerciais, setInformacoesComerciais)
              }
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Comissão %</label>
            <input
              name="comissaoPercentual"
              value={informacoesComerciais.comissaoPercentual}
              onChange={(e) =>
                handleChange(e, informacoesComerciais, setInformacoesComerciais)
              }
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Comissão R$</label>
            <input
              name="comissaoValor"
              value={informacoesComerciais.comissaoValor}
              onChange={(e) =>
                handleChange(e, informacoesComerciais, setInformacoesComerciais)
              }
              className="inputText"
              type="text"
              readOnly
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Valor do IPTU</label>
            <input
              name="iptu"
              value={informacoesComerciais.iptu}
              onChange={(e) =>
                handleChange(e, informacoesComerciais, setInformacoesComerciais)
              }
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Valor do Condomínio</label>
            <input
              name="condominio"
              value={informacoesComerciais.condominio}
              onChange={(e) =>
                handleChange(e, informacoesComerciais, setInformacoesComerciais)
              }
              className="inputText"
              type="text"
            />
            <div></div>
          </div>
        </div>

        <h3>Informações Adicionais</h3>
        <div className="containerOne">
          <div className="input-groupText">
            <label className="labelText">Chave na imobiliária</label>
            <select
              name="chaveImobiliaria"
              value={informacoesAdicionais.chaveImobiliaria}
              onChange={(e) =>
                handleChange(e, informacoesAdicionais, setInformacoesAdicionais)
              }
              className="selectInputText"
              type="text"
            >
              <option value="" disabled>
                Selecione uma opção
              </option>
              <option value="true">SIM</option>
              <option value="false">NÃO</option>
            </select>
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Exclusivo</label>
            <select
              name="exclusivo"
              value={informacoesAdicionais.exclusivo}
              onChange={(e) =>
                handleChange(e, informacoesAdicionais, setInformacoesAdicionais)
              }
              className="selectInputText"
              type="text"
            >
              <option value="" disabled>
                Selecione uma opção
              </option>
              <option value="true">SIM</option>
              <option value="false">NÃO</option>
            </select>
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Possui Placa</label>
            <select
              name="placa"
              value={informacoesAdicionais.placa}
              onChange={(e) =>
                handleChange(e, informacoesAdicionais, setInformacoesAdicionais)
              }
              className="selectInputText"
            >
              <option value="" disabled>Selecione</option>
              <option value="true">SIM</option>
              <option value="false">NÃO</option>
            </select>
          </div>

          <div className="input-groupText">
            <label className="labelText">Parceria</label>
            <select
              name="parceria"
              value={informacoesAdicionais.parceria}
              onChange={(e) =>
                handleChange(e, informacoesAdicionais, setInformacoesAdicionais)
              }
              className="selectInputText"
            >
              <option value="" disabled>Selecione</option>
              <option value="true">SIM</option>
              <option value="false">NÃO</option>
            </select>
          </div>

          <div className="input-groupText">
            <label className="labelText">Nome da Parceria</label>
            <input
              name="nomeParceria"
              value={informacoesAdicionais.nomeParceria}
              onChange={(e) =>
                handleChange(e, informacoesAdicionais, setInformacoesAdicionais)
              }
              className="inputText"
              type="text"
              disabled={informacoesAdicionais.parceria !== "true"}
            />
          </div>

          <div className="input-groupText">
            <label className="labelText">N° IPTU</label>
            <input
              name="numeroIptu"
              value={informacoesAdicionais.numeroIptu}
              onChange={(e) =>
                handleChange(e, informacoesAdicionais, setInformacoesAdicionais)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">N° MATRÍCULA</label>
            <input
              name="numeroMatricula"
              value={informacoesAdicionais.numeroMatricula}
              onChange={(e) =>
                handleChange(e, informacoesAdicionais, setInformacoesAdicionais)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">CÓD. ÁGUA</label>
            <input
              name="codigoDamae"
              value={informacoesAdicionais.codigoDamae}
              onChange={(e) =>
                handleChange(e, informacoesAdicionais, setInformacoesAdicionais)
              }
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">N°. ENERGIA ELÉTRICA</label>
            <input
              name="numeroEnergiaEletrica"
              value={informacoesAdicionais.numeroEnergiaEletrica}
              onChange={(e) =>
                handleChange(e, informacoesAdicionais, setInformacoesAdicionais)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">N°. INSTALAÇÃO ELÉTRICA</label>
            <input
              name="numeroInstalacaoEletrica"
              value={informacoesAdicionais.numeroInstalacaoEletrica}
              onChange={(e) =>
                handleChange(e, informacoesAdicionais, setInformacoesAdicionais)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Link de Localização</label>
            <input
              name="linkLocalizacao"
              value={informacoesAdicionais.linkLocalizacao}
              onChange={(e) =>
                handleChange(e, informacoesAdicionais, setInformacoesAdicionais)
              }
              className="inputText"
              type="text"
            />
            <div></div>
          </div>
        </div>

        <h3>Galeria de Fotos</h3>
        <div className="containerOne">
          <input
            type="file"
            accept="image/png, image/jpeg, image/jpg"
            multiple
            onChange={handleImageChange}
            disabled={selectedImages.length >= MAX_IMAGES}
          />
          <p>
            {selectedImages.length} / {MAX_IMAGES} imagens selecionadas
          </p>

          <div className="gallery-preview">
            {selectedImages.filter(img => !img.toRemove).map((img, index) => (
              <div
                key={img.id}
                className="image-preview"
                draggable
                onDragStart={() => setDraggedId(img.id)}
                onDragOver={(e) => e.preventDefault()}
                onDrop={() => {
                  if (!draggedId) return;
                  setSelectedImages((prev) => {
                    const visible = prev.filter(x => !x.toRemove);
                    const removed = prev.filter(x => x.toRemove);

                    const fromIndex = visible.findIndex(x => x.id === draggedId);
                    const toIndex = visible.findIndex(x => x.id === img.id);

                    if (fromIndex === -1 || toIndex === -1) return prev;

                    const copy = [...visible];
                    const [moved] = copy.splice(fromIndex, 1);
                    copy.splice(toIndex, 0, moved);

                    return [...copy, ...removed];
                  });
                }}
              >
                <img src={img.url} alt="Preview" />
                <button
                  type="button"
                  onClick={() => handleRemoveImage(img.id)}
                >
                  Remover
                </button>
              </div>
            ))}
          </div>
        </div>

        <h3>Book Técnico (PDF)</h3>
        <div className="containerOne">
          <input
            type="file"
            accept="application/pdf"
            onChange={handleBookTecnicoChange}
          />

          {bookTecnicoURL && !bookTecnicoFile && (
            <div className="pdf-preview">
              <p>📄 <a href={bookTecnicoURL} target="_blank" rel="noopener noreferrer">Abrir Book Técnico atual</a></p>
              <button type="button" onClick={handleRemoveBookTecnico}>
                Remover PDF
              </button>
            </div>
          )}

          {bookTecnicoFile && (
            <div className="pdf-preview">
              <p>📄 {bookTecnicoFile.name}</p>
              <button type="button" onClick={handleRemoveBookTecnico}>
                Remover PDF
              </button>
            </div>
          )}
        </div>

        <h3>Descrição do imóvel</h3>
        <div className="containerOne">
          <textarea
            name="descricao"
            className="inputDescricao"
            placeholder="Digite a descrição do imóvel..."
            value={imovelInfo.descricao}
            onChange={(e) => handleChange(e, imovelInfo, setImovelInfo)}
            rows="10"
          />
        </div>
        <h3>Descrição Interna</h3>
        <div className="containerOne">
          <textarea
            name="descricaoInterna"
            className="inputDescricao"
            placeholder="Digite a descrição interna do imóvel..."
            value={imovelInfo.descricaoInterna}
            onChange={(e) => handleChange(e, imovelInfo, setImovelInfo)}
            rows="10"
          />
        </div>
      </div>
      <br />
      <br />

      <button className="float-save" onClick={handleSave}>
        SALVAR IMÓVEL
      </button>

      <Snackbar
        open={openAlert}
        autoHideDuration={8000}
        onClose={handleCloseAlert}
      >
        <Alert
          onClose={handleCloseAlert}
          severity={alertType}
          sx={{ width: "100%" }}
        >
          {alertMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default EditImovel;
